import React, { useState, useEffect } from 'react';
import '../styles/InstructorCard.css';

const InstructorCard = ({ instructor }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // デバイスサイズに応じてモバイルかどうかを判定
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // 初期判定
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleBio = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`instructor-card ${isMobile ? 'mobile' : 'desktop'}`}>
      <img src={instructor.photo} alt={instructor.name} className="instructor-photo" />
      <div className="instructor-content">
        <div className="instructor-name-container">
          <h3 className="instructor-name">{instructor.name}</h3>
          <img
            src="https://www.eltschool.jp/wp-content/uploads/2020/08/flag_circle_uk.svg"
            alt="UK Flag"
            className="instructor-flag"
          />
        </div>
        <p className={`instructor-bio ${!isExpanded ? 'collapsed' : 'expanded'}`}>
          {instructor.bio}
        </p>
        <button className="toggle-button" onClick={toggleBio}>
          {isExpanded ? '閉じる' : 'もっと読む'}
        </button>
      </div>
    </div>
  );
};

export default InstructorCard;

